import React from 'react';
import { FILTER_COLLATION, FILTER_OPERATION, ModelRenderer } from '@veeam/core';
import { AdvancedFilter } from "../../AdvancedFilter";
export function toolbarAdvancedFilter(_a) {
    var valueTitle = _a.valueTitle, filtersTitle = _a.filtersTitle, decorators = _a.decorators, disabled = _a.disabled, groups = _a.groups;
    return {
        decorators: decorators,
        disabled: disabled,
        render: function (model, _a) {
            var disabled = _a.disabled;
            return (React.createElement(ModelRenderer, { model: model, render: function (_a) {
                    var filters = _a.value.filters;
                    var columns = [];
                    var values = [];
                    groups.forEach(function (_a) {
                        var items = _a.items, _b = _a.groupId, groupId = _b === void 0 ? '' : _b, property = _a.property;
                        items.forEach(function (item) {
                            var filterValue = filters.getFilterValue({
                                property: property,
                                groupId: groupId
                            });
                            if (Array.isArray(filterValue) &&
                                filterValue.includes(item.value)) {
                                values.push({
                                    value: item.value,
                                    property: property,
                                    groupId: groupId
                                });
                            }
                        });
                    });
                    groups.map(function (_a) {
                        var _b = _a.columnIndex, columnIndex = _b === void 0 ? 0 : _b, _c = _a.groupId, groupId = _c === void 0 ? '' : _c, property = _a.property, title = _a.title, items = _a.items;
                        var _d;
                        if (!((_d = columns[columnIndex]) === null || _d === void 0 ? void 0 : _d.groups)) {
                            columns[columnIndex] = { groups: [] };
                        }
                        columns[columnIndex].groups.push({
                            title: title,
                            items: items.map(function (_a) {
                                var value = _a.value, title = _a.title, testId = _a.testId, icon = _a.icon;
                                return ({
                                    value: { value: value, property: property, groupId: groupId },
                                    label: title,
                                    iconSrc: icon,
                                    testId: testId
                                });
                            })
                        });
                    });
                    return (React.createElement(AdvancedFilter, { label: valueTitle, value: values, options: {
                            header: filtersTitle,
                            cols: columns
                        }, disabled: disabled, onChange: function (value) {
                            var separator = '|:|';
                            var nextGroupedValues = value.reduce(function (acc, curr) {
                                var key = "" + curr.property + separator + curr.groupId;
                                if (!acc[key]) {
                                    acc[key] = [];
                                }
                                acc[key].push(curr);
                                return acc;
                            }, {});
                            groups.forEach(function (_a) {
                                var _b = _a.groupId, groupId = _b === void 0 ? '' : _b, property = _a.property, _c = _a.operation, operation = _c === void 0 ? FILTER_OPERATION.in : _c, _d = _a.collation, collation = _d === void 0 ? FILTER_COLLATION.ignorecase : _d;
                                var key = "" + property + separator + groupId;
                                var nextItems = nextGroupedValues[key];
                                if (!nextItems || !nextItems.length) {
                                    model.setFilter({ property: property, groupId: groupId }, null);
                                    return;
                                }
                                model.setFilter({ property: property, groupId: groupId }, {
                                    operation: operation,
                                    collation: collation,
                                    value: nextItems.map(function (i) { return i.value; })
                                });
                            });
                        } }));
                } }));
        }
    };
}
//# sourceMappingURL=toolbarAdvancedFilter.js.map